<template>
  <div class="form-component">
    <p class="alert alert-info" v-if="form.helpTitle" v-html="form.helpTitle"></p>
    <div class="box box-primary">
      <div class="box-header">
        <h1 class="box-title">{{ form.title }}</h1>
      </div>
      <div class="box-body" v-if="form.sections">
        <div class="form-section-info" v-show="form.info">{{ form.info }}</div>
        <form class="form-horizontal" v-on:submit.prevent="submitForm" v-el:form="" enctype="multipart/form-data">
          <input type="hidden" name="permalink" v-bind:value="form.permalink"/>
          <template v-for="section in form.sections">
            <form-section v-if="section.type == 'formSection'" v-bind:section.sync="section"></form-section>
            <agreement-input v-if="section.type == 'agreement'" v-bind:field.sync="section"></agreement-input>
            <username-input v-if="section.type == 'username'" v-bind:field.sync="section"></username-input>
            <promo-code-input v-if="section.type == 'promo'" v-bind:field.sync="section"></promo-code-input>
            <password-input v-if="section.type == 'password'" v-bind:field.sync="section"></password-input>
            <password-confirm-input v-if="section.type == 'passwordConfirm'" v-bind:field.sync="section"></password-confirm-input>
            <textarea-input v-if="section.type == 'textarea'" v-bind:field.sync="section"></textarea-input>
            <text-input v-if="section.type == 'text'" v-bind:field.sync="section"></text-input>
            <postcode-input v-if="section.type == 'postcode'" v-bind:field.sync="section"></postcode-input>
            <hidden-input v-if="section.type == 'hidden'" v-bind:field.sync="section"></hidden-input>
            <email-input v-if="section.type == 'email'" v-bind:field.sync="section"></email-input>
            <phone-input v-if="section.type == 'phone'" v-bind:field.sync="section"></phone-input>
            <number-input v-if="section.type == 'number'" v-bind:field.sync="section"></number-input>
            <address-input v-if="section.type == 'address'" v-bind:field.sync="section"></address-input>
            <amazon-media-input v-if="section.type == 'amazonMedia'" v-bind:field.sync="section"></amazon-media-input>
            <amazon-media-multiple-input v-if="section.type == 'amazonMediaMultiple'" v-bind:field.sync="section"></amazon-media-multiple-input>
            <object-select-input v-if="section.type == 'objectSelect'" v-bind:field.sync="section"></object-select-input>
            <objects-select-input v-if="section.type == 'objectsSelect'" v-bind:field.sync="section"></objects-select-input>
            <date-input v-if="section.type == 'date'" v-bind:field.sync="section"></date-input>
            <date-time-range-input v-if="section.type == 'dateTimeRange'" v-bind:field.sync="section"></date-time-range-input>
            <checkbox-input v-if="section.type == 'checkbox'" v-bind:field.sync="section"></checkbox-input>
            <date-time-input v-if="section.type == 'date-time'" v-bind:field.sync="section"></date-time-input>
            <radio-input v-if="section.type == 'radio'" v-bind:field.sync="section"></radio-input>
            <reservation-change v-if="section.type == 'reservationChange'" v-bind:field.sync="section"></reservation-change>
            <account-type-select-input v-if="section.type == 'accountTypeSelect'" v-bind:field.sync="section"></account-type-select-input>
            <field-add-select-input v-if="section.type == 'fieldAddSelect'" v-bind:field.sync="section"></field-add-select-input>
            <credit-card-input v-if="section.type == 'creditCardInput'" v-bind:field.sync="section"></credit-card-input>
            <div class="row" v-if="section.info">
              <div v-bind:class="{ 'col-sm-offset-4' : section.type !== 'formSection', 'col-sm-8' : section.type !== 'formSection', 'col-sm-12' : section.type == 'formSection' }">
                <div class="form-section-info" v-html="section.info"></div>
              </div>
            </div>
          </template>
          <div class="row" v-show="formError" transition="expand">
            <div class="col-sm-8 col-sm-offset-4">
              <div class="form-section-danger">{{ formError }}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-4 col-sm-offset-4 col-xs-6">
            <a v-link="{ path: '/forgot-password' }" v-show="form.forgotPassword" class="btn btn-warning btn-sm margin-bottom"> Forgot password? </a><br/>
            <a v-link="{ path: '/sign-up' }" v-show="form.forgotPassword" class="btn btn-info btn-sm"> Create Account </a>
            </div>
            <div class="col-sm-4 col-xs-6 submit-button" v-if="form.formType == 'login'">
              <button class="btn btn-default" type="submit">{{ form.submit }}</button>
            </div>
            <div class="col-sm-8 col-sm-offset-4 submit-button" v-if="form.submit && form.formType != 'login'">
              <button class="btn btn-default" type="submit">{{ form.submit }}</button>
            </div>
          </div>
        </form>
      </div>
      <div class="form-links" v-if="form.links">
        <p v-html="form.links"></p>
      </div>
      <div class="form-footer" v-if="form.footer">
        <h2>{{ form.footer.title }}</h2>
        <p v-html="form.footer.html"></p>
      </div>
    </div>
    <!-- Confirmation Modal -->
    <div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog" aria-labelledby="confirmationModalLabel" v-if="form.confirmation">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="confirmationModalLabel">Success!</h4>
          </div>
          <div class="modal-body">
            <div class="form-section-success" v-if="form.confirmation">{{{ form.confirmation }}}</div>
            <template v-for="section in form.sections">
              <username-display v-if="section.type == 'username'" v-bind:field.sync="section"></username-display>
              <password-display v-if="section.type == 'password'" v-bind:field.sync="section"></password-display>
              <text-display v-if="section.type == 'text'" v-bind:field.sync="section"></text-display>
              <email-display v-if="section.type == 'email'" v-bind:field.sync="section"></email-display>
              <phone-display v-if="section.type == 'phone'" v-bind:field.sync="section"></phone-display>
              <number-display v-if="section.type == 'number'" v-bind:field.sync="section"></number-display>
              <address-display v-if="section.type == 'address'" v-bind:field.sync="section"></address-display>
            </template>
          </div>
          <div class="modal-footer">
            <button v-if="form.redirect && !form.noEdit" type="button" class="btn btn-default pull-left" data-dismiss="modal">Edit</button>
            <a v-if="form.redirect" v-link="form.redirect" class="btn btn-default" data-dismiss="modal">Continue</a>
            <a v-if="form.externalRedirect" v-bind:href="form.externalRedirect" class="btn btn-default">Continue</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormSection from './FormSection.vue'
// Inputs
import UsernameInput from './inputs/UsernameInput.vue'
import PasswordInput from './inputs/PasswordInput.vue'
import PasswordConfirmInput from './inputs/PasswordConfirmInput.vue'
import TextInput from './inputs/TextInput.vue'
import PostcodeInput from './inputs/PostcodeInput.vue'
import HiddenInput from './inputs/HiddenInput.vue'
import TextareaInput from './inputs/TextareaInput.vue'
import EmailInput from './inputs/EmailInput.vue'
import PhoneInput from './inputs/PhoneInput.vue'
import NumberInput from './inputs/NumberInput.vue'
import AddressInput from './inputs/AddressInput.vue'
import AmazonMediaInput from './inputs/AmazonMediaInput.vue'
import AmazonMediaMultipleInput from './inputs/AmazonMediaMultipleInput.vue'
import ObjectSelectInput from './inputs/ObjectSelectInput.vue'
import ObjectsSelectInput from './inputs/ObjectsSelectInput.vue'
import DateInput from './inputs/DateInput.vue'
import DateTimeRangeInput from './inputs/DateTimeRangeInput.vue'
import CheckboxInput from './inputs/CheckboxInput.vue'
import AgreementInput from './inputs/AgreementInput.vue'
import DateTimeInput from './inputs/DateTimeInput.vue'
import AccountTypeSelectInput from './inputs/AccountTypeSelectInput.vue'
import RadioInput from './inputs/RadioInput.vue'
import ReservationChange from './inputs/ReservationChange.vue'
import FieldAddSelectInput from './inputs/FieldAddSelectInput.vue'
import CreditCardInput from './inputs/CreditCardInput.vue'
import PromoCodeInput from './inputs/PromoCodeInput.vue'
// Displays
import UsernameDisplay from './displays/UsernameDisplay.vue'
import PasswordDisplay from './displays/PasswordDisplay.vue'
import TextDisplay from './displays/TextDisplay.vue'
import EmailDisplay from './displays/EmailDisplay.vue'
import PhoneDisplay from './displays/PhoneDisplay.vue'
import NumberDisplay from './displays/NumberDisplay.vue'
import AddressDisplay from './displays/AddressDisplay.vue'

export default {
  name: 'Form',
  components: {
    // inputs
    PromoCodeInput,
    CreditCardInput,
    AgreementInput,
    UsernameInput,
    PasswordInput,
    PasswordConfirmInput,
    TextInput,
    PostcodeInput,
    HiddenInput,
    TextareaInput,
    EmailInput,
    PhoneInput,
    NumberInput,
    AddressInput,
    AmazonMediaInput,
    ObjectSelectInput,
    ObjectsSelectInput,
    DateInput,
    DateTimeRangeInput,
    CheckboxInput,
    DateTimeInput,
    AccountTypeSelectInput,
    AmazonMediaMultipleInput,
    RadioInput,
    ReservationChange,
    FieldAddSelectInput,
    // displays
    UsernameDisplay,
    PasswordDisplay,
    TextDisplay,
    EmailDisplay,
    PhoneDisplay,
    NumberDisplay,
    AddressDisplay,
    FormSection
  },
  data () {
    return {
      form: {
        permalink: 'form',
        title: 'Loading Form...',
        submit: 'Loading...',
        submitting: 'Processing...',
        confirmation: false,
        redirect: '/',
        sections: []
      },
      validForm: false,
      formError: false,
      sending: false
    }
  },
  route: {
    data () {
      let permalink = this.$route.vueForm
      let params = this.$route.params
      let authType = this.$route.authType
      if (this.$route.query.ma) {
        params = this.$route.query
        this.$http.get(`${authType}/get-drivers`, { params }).then((response, status, request) => {
          if (response.data.maxAccounts) {
            if (response.data.drivers === response.data.maxAccounts) {
              this.$route.router.go('/account-limit-reached')
            }
          }
        })
      }
      this.$http.get(`${authType}/form`, { params: { permalink, params } }).then((response, status, request) => {
        let body = response.json()
        this.form = body.form
      })
    }
  },
  watch: {
    'form.sections': {
      handler: function (sections, oldVal) {
        this.validForm = false
        let totalFields = sections.length
        let validFields = 0
        for (let field of sections) {
          if (field.required) {
            if (field.valid || field.type === 'formSection') validFields++
          } else {
            validFields++
          }
        }
        if (validFields === totalFields) this.validForm = true
      },
      deep: true
    }
  },
  methods: {
    submitForm (e) {
      if (this.validForm) {
        let authType = this.$route.authType
        for (let input in this.$children) {
          if (this.$children[input].constructor.name === 'BucketInput') {
            let select = this.$children[input].$els.values
            for (let i = 0; i < select.options.length; i++) {
              select.options[i].selected = true
            }
          }
        }
        let formData = $(this.$els.form).serializeObject()
        let submitMessage = this.$data.form.submit
        let method = this.$route.vueFormMethod
        this.formError = false
        formData.params = this.$route.params
        this.form.submit = this.$data.form.submitting
        this.sending = true
        $('.form-loading-tooltip').addClass('is-loading')
        this.$http[method](`${authType}/form`, formData).then((response, status, request) => {
          if (this.$route.loginPage) {
            window.sessionStorage.setItem('token', response.data.result)
            this.$root.loggedIn = true
          }
          this.sending = false
          this.form.submit = submitMessage
          $('.form-loading-tooltip').removeClass('is-loading')
          if (this.form.confirmation) {
            $('#confirmationModal').modal()
          } else if (this.$root.fromPath && this.$root.fromPath !== '/' && this.$root.fromPath !== '/login') {
            this.$route.router.go(this.$root.fromPath)
          } else if (this.form.redirect) this.$route.router.go(this.form.redirect)
        }).catch((response, status, request) => {
          this.sending = false
          this.form.submit = submitMessage
          $('.form-loading-tooltip').removeClass('is-loading')
          this.formError = response.body
        })
      } else {
        for (let input in this.$children) {
          let $input = this.$children[input]
          if ($input.constructor.name === 'BucketInput') {
            let select = $input.$els.values
            for (let i = 0; i < select.options.length; i++) {
              select.options[i].selected = true
            }
          }
          if ($input.field) {
            $input.field.dirty = true
          }
        }
        this.formError = 'You did not fill all fields correctly'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?7fe4df7c